import { colors } from '@lmc/common/constants'
import type { HomeSource } from '@lmc/ts-common'
import {
  DocumentsModuleCard,
  EmarModuleCard,
  GroupPlanModuleCard,
  IconType
} from '@lmc/ui-kit'
import type React from 'react'
import { connect } from 'react-redux'
import { PaywallTemplateWrapper } from '../PaywallTemplateWrapper'

interface StateProps {
  source?: HomeSource
}

export const FamilyPortalPaywallComponent: React.FC<StateProps> = ({
  source
}) => {
  const isSelfServe = source === 'Self-serve'

  return (
    <PaywallTemplateWrapper
      backgroundColor="#FF9900"
      title="Family App"
      subTitle="Show the quality of your service and bring out the human touch by keeping relatives updated about their loved one’s care, wellbeing and health."
      bodyText={
        isSelfServe
          ? 'Set up the Family App to best fit your care service'
          : 'Use the Family App to improve communication.'
      }
      icon={IconType.FamilyHexagon}
      videoUrl="https://www.youtube.com/embed/2XCgAbKwzvQ"
      articles={[
        {
          title: 'How can I set up and manage the Family App?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/collections/2560231-manage-your-family-portal',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white
        },
        {
          title: 'How can families stay informed?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/collections/2616115-help-for-families-and-loved-ones-using-the-app',
          iconBackgroundColour: colors.green,
          iconColour: colors.white
        },
        {
          title: 'What can I do with the Family App add-on?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/2455677-family-portal',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white
        }
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={
        isSelfServe ? <DocumentsModuleCard /> : <GroupPlanModuleCard />
      }
      findOutMoreURL={
        isSelfServe
          ? 'https://support.logmycare.co.uk/en/articles/4498174-how-can-i-set-up-the-family-portal'
          : 'https://www.logmycare.co.uk/features/updating-family-friends'
      }
      customLinkText="Read more"
    />
  )
}

const mapStateToProps = (state: any) => ({
  source: state.global?.home?.source
})

export const FamilyPortalPaywall = connect(mapStateToProps)(
  FamilyPortalPaywallComponent
)
